import {
  Bollard,
  EquipmentTypes,
  GateDirection,
  LayoutObjectType,
  NamingSchema,
} from '@yard/app/api'

export interface IYardBlockFormData {
  name: string
  maxBays: number
  maxRows: number
  maxTiers: number
  bayNamingSchema: NamingSchema
  rowNamingSchema: NamingSchema
  equipmentTypes?: EquipmentTypes[]
  acceptedLengths?: number[]
  description?: string
}

export interface IBayFormData {
  name: string
}

export interface IRowFormData {
  name: string
}

export interface ILimitStackHeightConfigAreaFormData {
  stackHeight: number
}

export interface ISpaceBetweenBaysConfigAreaFormData {
  widthInMeters: number
}

export interface IFlexibleBlockFormData {
  name: string
  equipmentTypes?: EquipmentTypes[]
  acceptedLengths?: number[]
  description?: string
}

export interface ILayoutObjectFormData {
  name: string
  type: LayoutObjectType
  file?: File
  description?: string
  color?: string
  opacity?: number
  // Gate-specific — only relevant when type === Gate.
  code?: string
  direction?: GateDirection
  active?: boolean
}

export interface IBerthFormData {
  name: string
  quayMeterMarkFrom: number
  quayMeterMarkTo: number
  maxDraft?: number
  pierId: string
  bollards: Bollard[]
}

export interface IRailTrackFormData {
  name: string
  length?: number
}

export enum HousekeepingPlanSequencingStrategy {
  OperatorConvenience = 'OperatorConvenience',
}

export enum HousekeepingPlanFillDirection {
  BayFirst = 'BayFirst',
  RowFirst = 'RowFirst',
}

export interface ICreateHousekeepingPlanFormData {
  name: string
  blockId: string
  sequencingStrategy: HousekeepingPlanSequencingStrategy
  fillDirection: HousekeepingPlanFillDirection
  dispatchWhatFits: boolean
}
